module.exports = __webpack_public_path__ + "img/ab0eace.jpg";